import {Card, LinearProgress} from '@mui/material';

export type CareServicesBodyProps = {
  isLoading?: boolean;
  children?: React.ReactNode;
  noPadding?: boolean;
};

export function CareServicesBody(props: CareServicesBodyProps) {
  return (
    <Card
      elevation={0}
      sx={{
        px: props.noPadding ? 0 : '9px',
        py: props.noPadding ? 0 : '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        height: 'calc(100vh - 210px)',
        position: 'relative',
      }}
    >
      {/* --------- LOADING --------- */}
      {props.isLoading && (
        <LinearProgress
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        />
      )}

      {/* --------- REST --------- */}
      {props.children}
    </Card>
  );
}
